const version = {
    version: parseInt(`${process.env.version}`.toString().replaceAll(".", "")),
    versionStr: `${process.env.version}`.toString(),
    buildNumber: process.env.buildNumber || -1,
    commitHash: `${process.env.commitHash}`.toString(),
};
export default version;



// WEBPACK FOOTER //
// ./src/utils/version.js